module.exports = __webpack_public_path__ + "static/media/player_level.eae8dac4.png";